import { AppEntityManager } from '../entities/AppEntityManager';

/**
 * a simple interface to access page specific data from the browser console
 */
export class DebugInterface {
  public static entityManager: AppEntityManager | null;
}
(window as any).DebugInterface = DebugInterface;